module.exports = __webpack_public_path__ + "assets/img/footer_logo_5.3e1208ec.png";